<template>
  <div ref="mainOrder" class="main-order">
    <!--交易方向-->
    <OrderActionField />
    <!--订单类型  -->
    <OrderTypeField :contract="contract" />
    <!--止损价  -->
    <OrderStpPriceField v-if="isSTP" :min-ticks="minTicks" />
    <!--限价单  -->
    <OrderLimitPriceField v-if="isLMT" :min-ticks="minTicks" />
    <!--追踪单（价格）-->
    <OrderTrailPriceField v-if="isTRAIL2" :min-ticks="minTicks" />
    <!--追踪单（百分比）-->
    <OrderTrailPercentField v-if="isTRAIL" />
    <!--数量 -->
    <OrderQuantityField
      :max-quantity="maxQuantity"
      :position-num="positionNum"
      :is-leveraged="isLeveraged"
    />
    <!-- 仓位 -->
    <OrderPositionField
      v-if="showPositionField"
      :max-quantity="maxQuantity"
      :position-num="positionNum"
      :is-leveraged="isLeveraged"
    />
    <!--金额  -->
    <OrderTotalMoneyField v-if="isLMT" />
    <!--有效期  -->
    <OrderTimeInForceField :list="availableTimeInForce" />
    <!--盘后交易  -->
    <OrderRthField v-if="showRthField" />
    <!-- 盈亏曲线 -->
    <ProfitLoss
      v-if="isOPT"
      :position="positionNum"
      :stock="stock"
      :order="order"
      context="trade"
      :is-detail="false"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import OrderActionField from './OrderFields/ActionField.vue'
import OrderTypeField from './OrderFields/TypeField.vue'
import OrderRthField from './OrderFields/RthField.vue'
import OrderLimitPriceField from './OrderFields/LimitPriceField.vue'
import OrderStpPriceField from './OrderFields/StpPriceField.vue'
import OrderQuantityField from './OrderFields/QuantityField.vue'
import OrderTrailPriceField from './OrderFields/TrailPriceField.vue'
import OrderTrailPercentField from './OrderFields/TrailPercentField.vue'
import OrderPositionField from './OrderFields/PositionField.vue'
import OrderTotalMoneyField from './OrderFields/TotalMoneyField.vue'
import OrderTimeInForceField from './OrderFields/TimeInForceField.vue'
import ProfitLoss from 'mod/ProfitLoss'
import getTradeMaxQuantity from 'utils/getTradeMaxQuantity'
import { ORDER_TYPE } from 'const/trade'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

export default {
  name: 'MainOrder',
  components: {
    OrderActionField,
    OrderTypeField,
    OrderRthField,
    OrderStpPriceField,
    OrderLimitPriceField,
    OrderQuantityField,
    OrderPositionField,
    OrderTotalMoneyField,
    OrderTimeInForceField,
    OrderTrailPriceField,
    OrderTrailPercentField,
    ProfitLoss
  },
  props: ['positionNum'],
  data() {
    return {
      holding: null
    }
  },
  computed: {
    ...mapGetters(['tradeRequest', 'isIb', 'asset']),
    contract() {
      return this.tradeRequest.contract
    },
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    isOPT() {
      return this.stock.secType === SEC_TYPE.OPT
    },
    isLMT() {
      return [ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(this.order.orderType)
    },
    isSTP() {
      return [ORDER_TYPE.STP, ORDER_TYPE.STP_LMT].includes(this.order.orderType)
    },
    // 跟踪（价格）
    isTRAIL2() {
      return this.order.orderType === ORDER_TYPE.TRAIL_2
    },
    // 跟踪单（百分比）
    isTRAIL() {
      return this.order.orderType === ORDER_TYPE.TRAIL_1
    },
    minTicks() {
      return this.contract ? this.contract.tickSizes : []
    },
    shortableCount() {
      return this.contract ? this.contract.shortableCount : 0
    },
    availableTimeInForce() {
      return this.contract ? this.contract.availableTimeInForce : []
    },
    orderPrice() {
      if (this.isLMT) {
        return Number(this.order.limitPrice)
      }
      return Number(this.stock.latestPrice)
    },
    maxQuantity() {
      return this.getMaxQuantity()
    },
    isLeveraged() {
      return this.asset && this.asset.leverage > 1
    },
    showPositionField() {
      // 平仓不显示仓位
      if (this.tradeRequest.isCloseOut) return false
      // FIXME: 持仓卖出或者空仓买入需要展示杠杆
      if (this.isOPT || this.isLeveraged) return false
      if (this.order.action === 'BUY') return true
      return this.positionNum > 0
    },
    showRthField() {
      return (
        this.stock.market === MARKET_TYPE.US &&
        this.stock.secType === SEC_TYPE.STK
      )
    }
  },
  methods: {
    // 获取可交易最大仓位
    getMaxQuantity() {
      if (this.order.action === 'BUY') {
        if (this.positionNum < 0) return Math.abs(this.positionNum)
        if (this.isLeveraged) return 0
        if (this.orderPrice) {
          return getTradeMaxQuantity(
            this.stock,
            this.asset.cashBalance,
            1,
            this.orderPrice
          )
        }
      } else {
        if (this.positionNum > 0) return Math.abs(this.positionNum)
        if (this.isLeveraged) return 0
        if (this.shortableCount <= 0) return 0
        if (this.orderPrice) {
          return getTradeMaxQuantity(
            this.stock,
            this.asset.cashBalance,
            1,
            this.orderPrice
          )
        }
      }
    }
  }
}
</script>
